/** Тип баббла «Инфо о клиенте». Такой баббл показываем только в мобильной версии. */
export const CLIENT_INFO_BUBBLE_TYPE = 'ClientInfo';
